import React from 'react';
import { Box, Typography } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import useMessageStyles from '../../../hooks/useMessageStyles';
import {
  getFileDisplayName,
  getFileExtension,
  getFileTypeLabel,
} from '../../../utils/fileDisplayUtils';

function DocumentIcon({ extension }) {
  const { messageDocumentIconSx, messageDocumentIconLabelSx } = useMessageStyles();

  if (extension === 'pdf') {
    return (
      <Box sx={messageDocumentIconSx}>
        <PictureAsPdfOutlinedIcon sx={{ fontSize: 26 }} />
      </Box>
    );
  }

  return (
    <Box sx={messageDocumentIconSx}>
      {extension ? (
        <Typography component="span" sx={messageDocumentIconLabelSx}>
          {getFileTypeLabel(`file.${extension}`)}
        </Typography>
      ) : (
        <InsertDriveFileOutlinedIcon sx={{ fontSize: 24 }} />
      )}
    </Box>
  );
}

export default function MessageDocumentCard({
  fileName = 'Document',
  fileUrl,
  subtitle,
  onClick,
}) {
  const {
    messageDocumentCardSx,
    messageDocumentTitleSx,
    messageDocumentMetaSx,
  } = useMessageStyles();

  const displayName = getFileDisplayName(fileName);
  const extension = getFileExtension(displayName);
  const meta =
    subtitle || `${getFileTypeLabel(displayName)} · Tap to open`;

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
      return;
    }
    if (fileUrl) {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const content = (
    <>
      <DocumentIcon extension={extension} />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography sx={messageDocumentTitleSx} noWrap title={displayName}>
          {displayName}
        </Typography>
        <Typography sx={messageDocumentMetaSx}>{meta}</Typography>
      </Box>
    </>
  );

  if (!fileUrl && !onClick) {
    return (
      <Box sx={{ ...messageDocumentCardSx, cursor: 'default' }}>{content}</Box>
    );
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      sx={{
        ...messageDocumentCardSx,
        width: '100%',
        textAlign: 'left',
        cursor: 'pointer',
      }}
      aria-label={`Open ${displayName}`}
    >
      {content}
    </Box>
  );
}
